import { NS_SVG } from "../constants";

export function SVG_DrawFilledCircle(
  cx,
  cy,
  radius,
  strokeColor,
  strokeWidth,
  fillColor,
  svgElement
) {
  var circleObj = document.createElementNS(NS_SVG, "circle");
  circleObj.setAttribute("cx", cx);
  circleObj.setAttribute("cy", cy);
  circleObj.setAttribute("r", radius);
  circleObj.setAttribute("fill", fillColor);
  circleObj.setAttribute("stroke", strokeColor);
  circleObj.setAttribute("stroke-width", strokeWidth);

  svgElement.appendChild(circleObj);
  return circleObj;
}
